<template>
<div>
	<van-nav-bar :title="$t('common.pldtitle')" left-text="" @click-left="back()" left-arrow >
	</van-nav-bar>
	<div class="content">
		<div style="display: flex; align-items: center; padding: 10px 0px 0px;">
			<svg t="1721097804862" class="icon" viewBox="0 0 1024 1024" version="1.1"
			xmlns="http://www.w3.org/2000/svg" p-id="5354" width="30" height="30"
			style="margin-right: 15px;">
				<path d="M102.4 102.4m307.2 0l204.8 0q307.2 0 307.2 307.2l0 204.8q0 307.2-307.2 307.2l-204.8 0q-307.2 0-307.2-307.2l0-204.8q0-307.2 307.2-307.2Z"
				fill="#FC7E7E" fill-opacity=".2" p-id="5355">
				</path>
				<path d="M665.6 481.28a81.92 81.92 0 0 1 81.92 81.92v20.48a81.92 81.92 0 0 1-81.92 81.92H336.67072l-54.97856 62.01344 9.54368-66.29376A81.95072 81.95072 0 0 1 235.52 583.68v-20.48a81.92 81.92 0 0 1 81.92-81.92z m30.72-225.28a81.92 81.92 0 0 1 81.92 81.92v20.48c0 33.11616-19.6608 61.6448-47.93344 74.55744L737.28 501.76l-38.42048-61.48096A83.43552 83.43552 0 0 1 696.32 440.32H450.56a81.92 81.92 0 0 1-81.92-81.92v-20.48a81.92 81.92 0 0 1 81.92-81.92h245.76z"
				fill="#FC7E7E" fill-opacity=".4" p-id="5356">
				</path>
				<path d="M634.88 532.48a81.92 81.92 0 0 1 81.92 81.92v20.48a81.92 81.92 0 0 1-81.92 81.92H305.95072l-54.97856 62.01344 9.54368-66.29376A81.95072 81.95072 0 0 1 204.8 634.88v-20.48a81.92 81.92 0 0 1 81.92-81.92z m102.4-225.28a81.92 81.92 0 0 1 81.92 81.92v20.48c0 33.11616-19.6608 61.6448-47.93344 74.55744L778.24 552.96l-38.42048-61.48096A83.43552 83.43552 0 0 1 737.28 491.52H491.52a81.92 81.92 0 0 1-81.92-81.92v-20.48a81.92 81.92 0 0 1 81.92-81.92h245.76z"
				fill="#FC7E7E" p-id="5357">
				</path>
				<path d="M341.68832 607.04768c5.85728 0 10.38336 1.86368 13.84448 5.59104 3.9936 3.72736 5.85728 8.51968 5.85728 14.37696 0 5.3248-1.86368 10.11712-5.85728 14.11072-3.46112 3.46112-7.9872 5.3248-13.84448 5.3248-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.9936-5.85728-8.78592-5.85728-14.11072 0-5.85728 2.12992-10.6496 5.85728-14.37696 3.9936-3.72736 8.78592-5.59104 14.11072-5.59104z m258.2528 0c5.3248 0 9.85088 1.59744 13.57824 5.3248 3.9936 3.46112 5.85728 7.9872 5.85728 13.57824 0 5.3248-1.86368 9.85088-5.85728 13.57824a18.4832 18.4832 0 0 1-13.57824 5.59104c-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.72736-5.59104-8.25344-5.59104-13.84448s1.86368-10.11712 5.59104-13.57824c3.72736-3.72736 8.51968-5.3248 14.11072-5.3248z m-88.92416 0c5.3248 0 9.85088 1.59744 13.57824 5.3248 3.9936 3.46112 5.85728 7.9872 5.85728 13.57824 0 5.3248-1.86368 9.85088-5.85728 13.57824a18.4832 18.4832 0 0 1-13.57824 5.59104c-5.3248 0-10.11712-1.86368-14.11072-5.3248-3.72736-3.72736-5.59104-8.25344-5.59104-13.84448s1.86368-10.11712 5.59104-13.57824c3.72736-3.72736 8.51968-5.3248 14.11072-5.3248z m-88.65792 0c5.3248 0 10.11712 1.59744 13.84448 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824 0 5.3248-1.86368 9.85088-5.59104 13.57824a19.08736 19.08736 0 0 1-13.84448 5.59104c-5.3248 0-10.11712-1.86368-13.84448-5.3248a18.8928 18.8928 0 0 1-5.85728-13.84448c0-5.59104 1.86368-10.11712 5.59104-13.57824 3.72736-3.72736 8.51968-5.3248 14.11072-5.3248zM510.95552 378.88c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-1.86368 10.11712-5.59104 13.84448c-3.9936 3.46112-8.78592 5.3248-14.11072 5.3248-5.3248 0-9.85088-1.86368-13.57824-5.59104A17.75616 17.75616 0 0 1 491.52 397.78304c0-5.59104 1.86368-10.11712 5.85728-13.57824 3.72736-3.72736 8.25344-5.3248 13.57824-5.3248z m88.92416 0c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-1.86368 10.11712-5.59104 13.84448c-3.9936 3.46112-8.78592 5.3248-14.11072 5.3248-5.3248 0-9.85088-1.86368-13.57824-5.59104a17.75616 17.75616 0 0 1-5.85728-13.57824c0-5.59104 1.86368-10.11712 5.85728-13.57824 3.72736-3.72736 8.25344-5.3248 13.57824-5.3248z m88.65792 0c5.59104 0 10.38336 1.59744 14.11072 5.3248 3.72736 3.46112 5.59104 7.9872 5.59104 13.57824s-2.12992 10.11712-5.85728 13.84448c-3.72736 3.46112-8.51968 5.3248-13.84448 5.3248-5.3248 0-10.11712-1.86368-13.84448-5.59104a18.4832 18.4832 0 0 1-5.59104-13.57824c0-5.59104 1.86368-10.11712 5.59104-13.57824 3.72736-3.72736 8.51968-5.3248 13.84448-5.3248z"
				fill="#FC3C3C" p-id="5358">
				</path>
			</svg>
			<b style="font-size: 16px;">
				{{plInfo.title}}
			</b>
		</div>
		<span style="font-size: 12px; color: rgb(102, 102, 102); padding-left: 44px; display: block; padding-bottom: 10px;">
			{{$t('author')}}{{plInfo.auther}}
		</span>
		<p>
			{{plInfo.content}}
		</p>
		<b style="text-align: right; padding: 20px 0px; display: block; color: rgb(136, 136, 136); font-weight: 400;">
			{{plInfo.time}}
		</b>
	</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      plInfo:{},
    };
  },
  methods: {
    back(){
      this.$router.push({path:'Pl'})
    },
    getVideoInfo(){
      this.$http({
        method: 'get',
        data:{id:this.$route.query.id},
        url: 'pinglun_get_info'
      }).then(res=>{
        this.plInfo = res.data;
      })

    },

  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getVideoInfo();
    }
  }
};
</script>

<style lang='less' scoped>
.van-nav-bar {
	position: relative;
	z-index: 999;
	height:3rem ;
	line-height: 3rem;
	background: url(/img/header.svg) no-repeat 50%/100%
}
.content {
    padding: .5rem;
    text-align: left
}
.van-nav-bar .van-icon{
	color: #fff;
}
.van-nav-bar .van-icon, .van-nav-bar__title {
    color: #fff;
}

</style>